import React from "react";
import { Descriptions, Empty, List, Space, Tag, Typography } from "antd";
import { TableWithFilter } from "@comps/components";
import { attendancePlannerPolicyDependencies } from "../policyDependencyConfig";
import { RulePreview } from "./AttendanceRulePreview";

const { Paragraph, Text, Title } = Typography;

const getName = (item) => item?.name || item?.title || item?.code || `#${item?.id}`;

const getSelectedRules = (record) => attendancePlannerPolicyDependencies
  .map((dependency) => {
    const rule = record?.[dependency.previewKey];
    const ruleId = record?.[dependency.field] || rule?.id;

    if (!ruleId && !rule) {
      return null;
    }

    return {
      dependency,
      ruleId,
      rule,
    };
  })
  .filter(Boolean);

const CreatePreview = ({ record, relatedData }) => {
  const employees = record?.employments || [];
  const selectedRules = getSelectedRules(record);

  return (
    <Space direction="vertical" size={ 18 } style={ { width: "100%" } }>
      <div className="attendance-final-review">
        <Title level={ 4 }>Final review</Title>
        <Paragraph type="secondary">
          Review what will happen in payroll before saving this employee policy package.
        </Paragraph>
      </div>

      <Descriptions size="small" column={ 1 } bordered>
        <Descriptions.Item label="Policy package">{ record?.name || "Not named" }</Descriptions.Item>
        <Descriptions.Item label="Effective from">{ record?.date || "Not selected" }</Descriptions.Item>
        <Descriptions.Item label="Employees">{ record?.for_all ? "All employees" : `${employees.length} selected employees` }</Descriptions.Item>
        <Descriptions.Item label="Attendance rules">{ selectedRules.length }</Descriptions.Item>
      </Descriptions>

      <div>
        <Title level={ 5 }>Salary and attendance effects</Title>
        { selectedRules.length ? (
          <List
            className="attendance-final-review__rules"
            dataSource={ selectedRules }
            renderItem={ ({ dependency, rule, ruleId }) => (
              <List.Item className="attendance-final-review__rule">
                <Space direction="vertical" size={ 10 } style={ { width: "100%" } }>
                  <Space wrap>
                    <Tag>{ dependency.label }</Tag>
                    <Text strong>{ rule ? getName(rule) : `Rule #${ruleId}` }</Text>
                  </Space>
                  { rule ? (
                    <RulePreview dependency={ dependency } record={ rule } relatedData={ relatedData } />
                  ) : (
                    <Paragraph type="secondary">
                      This rule is attached to the package. Open the policy to see its slabs and salary effect.
                    </Paragraph>
                  ) }
                </Space>
              </List.Item>
            ) }
          />
        ) : (
          <Empty image={ Empty.PRESENTED_IMAGE_SIMPLE } description="No attendance rules selected" />
        ) }
      </div>

      { employees.length > 0 && (
        <div>
          <Title level={ 5 }>Employees</Title>
          <div style={ { overflowY: "auto", maxHeight: "40vh" } }>
            <TableWithFilter
              columns={ [
                {
                  title: "Name",
                  dataIndex: "name",
                  key: "name",
                },
                {
                  title: "Designation",
                  dataIndex: "designation_name",
                  key: "designation",
                },
              ] }
              data={ employees }
            />
          </div>
        </div>
      ) }
    </Space>
  )
}

export default CreatePreview
